import React from 'react'
import { NavLink } from 'react-router-dom'
import { ReactComponent as InstagramIcon } from '../assets/instagram.svg'
import { ReactComponent as SearchIcon } from '../assets/search.svg'
import { ReactComponent as MenuIcon } from '../assets/menu.svg'
import LogoPng from '../assets/PLOGO.png'
import './Navbar.css'

export default function Navbar({ scrolled, onMenuToggle, onSearchToggle }) {
  const cls = scrolled ? 'navbar sticky' : 'navbar initial'

  return (
    <nav className={cls}>
      {/* Left side */}
      <div className="navbar-left">
        <a
          href="https://instagram.com/voices.of.virtue"
          target="_blank"
          rel="noopener noreferrer"
        >
          <InstagramIcon className="icon" />
        </a>
      </div>

      {/* Center logo */}
      <div className="navbar-center">
        <NavLink
          to="/"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="logo-link"
        >
          <img src={LogoPng} alt="Logo" className="logo" />
        </NavLink>
      </div>

      {/* Right side */}
      <div className="navbar-right">
        <MenuIcon className="icon" onClick={onMenuToggle} />
      </div>
    </nav>
  )
}